<div class="row">
    <div class="card">
        <div class="card-body">
            <div class=" d-flex justify-content-between mb-3" >
                <div>
                    <h4> Purchase Requisition </h4>
                </div>
                <div class="d-flex gap-3 align-items-center">
                    <button type="button" class="btn-close"  (click)="close()"
                        id="close-jobListModal" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
            </div>
            <div class="d-flex gap-3 justify-content-center">

                <div class="flex-grow-1" style="max-width: 50%;" *ngIf="payerModel">
                    <ng-container *ngTemplateOutlet="payerTemplate"></ng-container>
                </div>
                <div class="flex-grow-1" style="max-width: 50%;" *ngIf="model">
                    <ng-container *ngTemplateOutlet="clientPayerTemplate"></ng-container>
                </div>        

            </div>

            <div class="flex-grow-1" *ngIf="payerModel.paymentInfo">
                <ng-container *ngTemplateOutlet="creditcardTemplate"></ng-container>
            </div> 
            
            <div class="card">
                <div class="card-header">
                    <div class="d-flex">
                        <div class="flex-grow-1">
                            <h5 class="card-title mb-0">Order Summary</h5>
                        </div>
                    </div>
                </div>
                <div class="card-body "  >
                    <table class="table table-borderless align-middle mb-0">
                        <thead class="text-muted">
                            <tr>
                                <th style="width: 90px;" scope="col">Product</th>
                                <th scope="col">Product Info</th>
                                <th scope="col" class="text-end"> <span>Price</span><span  style=" margin-left: 26px; margin-right: 15px;">Tax</span></th>
                            </tr>
                        </thead>
                    
                        <tbody>

                            <ng-container  *ngTemplateOutlet ="requisitionPurchase"></ng-container>
                        
                        </tbody>

                    </table>
                  
                </div>
                <div class="card-body "  >
                    <div class="d-flex text-muted justify-content-end  gap-3 fs-12" >
                        <span>Non-taxable Sub-Total</span> {{invoice.subTotal|currency}}
                    </div>
                    <div class="d-flex text-muted justify-content-end gap-3 fs-12" >
                        <span>Total tax</span> {{invoice.hst|currency}}
                    </div>

                    <div class="d-flex justify-content-end fs-17 p-3 gap-3">
                        <span>Total</span> {{invoice.total|currency}}
                    </div>

                </div>
            </div>
            
            <div class = "d-flex justify-content-end gap-3">
                <div  style="display: flex; justify-content: end;"  ngbDropdown>
                    <button type="button" id="dropdownMenuLink1" data-bs-toggle="dropdown" aria-expanded="false"
                        class="btn btn-soft-info arrow-none display: flex; justify-content: end;" ngbDropdownToggle>
                        Actions <i class="ri-more-2-fill align-bottom"> </i>
                    </button>
                    <ul class="menu" aria-labelledby="dropdownMenuLink2" ngbDropdownMenu>
                        <li class="p-2" >
                            <button style="width: 100%;" class="btn btn-soft-primary" i18n = "@@" (click)="newItem()">Add Item</button>
                        </li>
                        <li class="p-2 ">
                            <button style="width: 100%;" class="btn btn-soft-primary" i18n = "@@">Create Cheque</button>
                        </li>
                    </ul>
                </div>
                
                <button class="btn btn-success" i18n = "@@"> Purchase</button>

            </div>
        </div>
    </div>
</div>

<ng-template #requisitionPurchase>

        <tr class="col-lg-4 mb-3" *ngFor="let lineItem of invoice.lineItems; let index = index ">
            <td>
                <div class="avatar-md bg-light rounded p-1">
                    <img src="{{getDocumentImageUrl(lineItem.image)}}" alt=""
                        class="img-fluid d-block">
                </div>
            </td>
            <td>
                
                <h5 *ngIf="lineItem.title"> {{lineItem.title}}</h5>
                <div class="fw-normal text-wrap ">{{lineItem.description}}</div>

            </td>
            <td>
                <div class=" d-flex justify-content-end gap-2" >
                    <div  style="display: flex; justify-content: end;"  ngbDropdown>
                        <button type="button" id="dropdownMenuLink1" data-bs-toggle="dropdown" aria-expanded="false"
                        class="btn btn-soft-info arrow-none display: flex; justify-content: end;" ngbDropdownToggle>
                    <i class="ri-more-2-fill align-bottom"></i>
                        </button>
                        <ul class="menu" aria-labelledby="dropdownMenuLink1" ngbDropdownMenu>
                            <li class="p-2" >
                                <button style="width: 100%;"class="btn btn-soft-primary"  i18n = "@@"> Edit Item</button>
                            </li>
                            <li class="p-2 ">
                                <button style="width: 100%;"  class="btn btn-soft-danger" i18n = "@@" (click)="removeItem(index)" > Remove Item</button>
                            </li>
                        </ul>
                    </div>
                    <div class="fs-14 p-1 align-bottom " >
                        {{lineItem.amount|currency}}
                    </div>
                    <div class=" d-flex justify-content-end gap-2" >
                        <div class="fs-14 p-1 align-bottom " >
                            {{lineItem.tax|currency}}
                        </div>
                    </div>
                    
                </div>
            </td>  
        
         
        </tr>
 
  
   
</ng-template>

<ng-template #payerTemplate >

        <div class="form-check card-radio">
            <input id="shippingAddress01" name="shippingAddress"  class="form-check-input" checked>
            <label class="form-check-label" for="shippingAddress01">
                <div class=" d-flex justify-content gap-2">
                    <div class="fw-bold text-muted text-uppercase flex-shrink fs-16">Invoice to</div>  <div class="fw-bold  mb-2 flex-grow-1 fs-16" >{{payerModel.fullName}} </div>
                </div>
                <div class="text-muted fw-normal text-wrap mb-1 d-block fs-16">
                    
                </div>
                <div class="text-muted fw-normal text-wrap mb-1 d-block">
                    <p style="margin: 0;">{{(payerModel.paymentInfo.billingAddress.unit)}} <span *ngIf="payerModel.paymentInfo.billingAddress.unit">-</span> {{payerModel.paymentInfo.billingAddress.address1}} </p> 
                    <p style="margin: 0;">{{payerModel.paymentInfo.billingAddress.city}}, {{payerModel.paymentInfo.billingAddress.province}} </p>
                    <p style="margin: 0;">{{payerModel.paymentInfo.billingAddress.postalCode}}</p> 
                </div>
                <span *ngIf="!payerModel.paymentInfo.billingAddress"> NO ADDRESS </span>
            
            </label>

        </div>

</ng-template>

<ng-template #clientPayerTemplate >

        <div class="form-check card-radio">
            <input id="shippingAddress01" name="shippingAddress"  class="form-check-input" checked>
            <label class="form-check-label" for="shippingAddress01">
                <div class=" d-flex justify-content gap-2">
                    <div class="fw-bold text-muted text-uppercase flex-shrink fs-16"> For Client</div>  <div class="fw-bold  mb-2 flex-grow-1 fs-16" >{{model.fullName}} </div>
                </div>
                <div class="text-muted fw-normal text-wrap mb-1 d-block fs-16">
                    
                </div>
                <div class="text-muted fw-normal text-wrap mb-1 d-block">
                    <p style="margin: 0;">{{(model.address.unit)}} <span *ngIf="model.address.unit">-</span> {{model.address.address1}} </p> 
                    <p style="margin: 0;">{{model.address.city}}, {{model.address.province}} </p>
                    <p style="margin: 0;">{{model.address.postalCode}}</p> 
                </div>
                <span *ngIf="!model.address"> NO ADDRESS </span>
            
            </label>

        </div>

</ng-template>

<ng-template #creditcardTemplate >

    <div class="collapse show" id="paymentmethodCollapse">
        <div class="card p-4 border shadow-none mb-0 mt-4">
            <div class="row gy-3">
                <div class="col-md-12">
                    <label for="cc-name" class="form-label">Name on card</label>
                    <input  disabled = true type="text" class="form-control" id="cc-name" placeholder="Enter name" value="{{payerModel.paymentInfo.cardHolderName}}">
                    <small class="text-muted"></small>
                </div>
    
                <div class="col-md-6">
                    <label for="cc-number" class="form-label">Credit card number</label>
                    <input disabled = true type="text" class="form-control" id="cc-number"
                        placeholder="xxxx xxxx xxxx xxxx" value="xxxx xxxx xxxx xxxx"> 
                </div>
    
                <div class="col-md-3">
                    <label for="cc-expiration" class="form-label">Expiration</label>
                    <input disabled = true type="text" class="form-control" id="cc-expiration"
                        placeholder="MM/YY" value="**/**" >
                </div>
    
                <div class="col-md-3">
                    <label for="cc-cvv" class="form-label">CVV</label>
                    <input  disabled = true type="text" class="form-control" id="cc-cvv" 
                    placeholder="xxx" value="***">
                </div>
            </div>
        </div>
        <div class="text-muted mt-2 fst-italic">
            <i data-feather="lock" class="text-muted icon-xs"></i> Your transaction is secured with SSL encryption
        </div>
    </div>

</ng-template>
